<template>
  <div class="advanced-options">
    <!-- Advanced Filter Row -->
    <v-row align="center">
      <!-- Logistics Filter -->
      <v-col cols="12" sm="6" md="3" lg="2">
        <TextSelect
          :dense="true"
          :placeholder="false"
          :items="logisticsList"
          label="logistics"
          itemValue="id"
          text="name"
          :returnObject="false"
          :searchable="false"
          v-model="filterData.logistics_id"
          @input="emitFilterChange"
          hide-details
        />
      </v-col>

      <!-- Customer Filter -->
      <v-col cols="12" sm="6" md="3" lg="2">
        <TextSelect
          :dense="true"
          :placeholder="false"
          :items="customersList"
          label="customer"
          itemValue="id"
          text="first_name"
          :returnObject="false"
          :searchable="false"
          v-model="filterData.customer_id"
          @input="emitFilterChange"
          hide-details
        />
      </v-col>

      <!-- Cashier Filter -->
      <v-col cols="12" sm="6" md="3" lg="2">
        <TextSelect
          :dense="true"
          :placeholder="false"
          :items="usersList"
          label="cashier"
          itemValue="id"
          text="first_name"
          :returnObject="false"
          :searchable="false"
          v-model="filterData.cashier_id"
          @input="emitFilterChange"
          hide-details
        />
      </v-col>

      <!-- Start Time -->
      <v-col cols="12" sm="6" md="1" lg="1">
        <v-text-field
          :dense="true"
          :label="$t('start_time')"
          type="time"
          v-model="filterData.start_time"
          outlined
          hide-details
          class="ps-text-field"
          @input="emitFilterChange"
        />
      </v-col>

      <!-- End Time -->
      <v-col cols="12" sm="6" md="1" lg="1">
        <v-text-field
          :dense="true"
          :label="$t('end_time')"
          type="time"
          v-model="filterData.end_time"
          outlined
          hide-details
          class="ps-text-field"
          @input="emitFilterChange"
        />
      </v-col>

      <!-- Verification Status Filter -->
      <v-col v-if="isTicketVerificationEnabled" cols="12" sm="6" md="3" lg="2">
        <div class="text-caption grey--text mb-1">
          {{ $t("verification_status") }}
        </div>
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="status in verificationStatusList"
            :key="status.value"
            x-small
            :color="
              status.value === filterData.verification_status
                ? 'primary'
                : 'grey lighten-2'
            "
            :text-color="
              status.value === filterData.verification_status
                ? 'white'
                : 'grey darken-1'
            "
            class="mr-1 mb-1"
            @click="updateVerificationStatus(status.value)"
            style="cursor: pointer"
          >
            {{ status.text }}
          </v-chip>
        </div>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import TextSelect from "@/components/global/TextSelect";

export default {
  name: "AdvancedReportFilter",
  components: {
    TextSelect,
  },
  props: {
    logisticsList: {
      type: Array,
      default: () => [],
    },
    customersList: {
      type: Array,
      default: () => [],
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    selectedTicketsCount: {
      type: Number,
      default: 0,
    },
    initialFilterData: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      filterData: {
        logistics_id: "all",
        customer_id: "all",
        cashier_id: "all",
        start_time: "",
        end_time: "",
        verification_status: "all",
        ...this.initialFilterData,
      },
    };
  },
  computed: {
    // Verification status list for filter
    verificationStatusList() {
      return [
        { value: "all", text: this.$t("all") },
        { value: "approved", text: this.$t("approved") },
        { value: "rejected", text: this.$t("rejected") },
      ];
    },

    // Check if ticket verification is enabled for this store
    isTicketVerificationEnabled() {
      return (
        this.user &&
        this.user.stores &&
        this.user.stores.ticket_verification === 1
      );
    },
  },
  watch: {
    initialFilterData: {
      handler(newData) {
        this.filterData = {
          ...this.filterData,
          ...newData,
        };
      },
      deep: true,
    },
  },
  methods: {
    updateVerificationStatus(status) {
      this.filterData.verification_status = status;
      this.emitFilterChange();
    },
    emitFilterChange() {
      this.$emit("filter-change", { ...this.filterData });
    },
    resetFilters() {
      this.filterData = {
        logistics_id: "all",
        customer_id: "all",
        cashier_id: "all",
        start_time: "",
        end_time: "",
        verification_status: "all",
      };
      this.emitFilterChange();
    },
  },
};
</script>

<style scoped>
.advanced-options {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 12px 16px;
  border: 1px solid #e9ecef;
}

/* Dark Theme Support */
.theme--dark .advanced-options {
  background-color: #2d2d2d;
  border-color: #404040;
}
</style>
